//@ts-strict-ignore
import React, { Component, ReactElement, ReactNode } from 'react';
import InputBlock from '../../connectedForm/InputBlock';
import InputGroup from '../../connectedForm/InputGroup';
import InputLabel, { IInputLabelProps } from '../../connectedForm/InputLabel';
import InputErrorMessage from '../../connectedForm/InputErrorMessage';
import Checkbox from '../../connectedForm/Checkbox';
import ICommonFieldProps from '../../../@types/ICommonFieldProps';
import { Maybe } from '../../../graphql/schema/p4types';

export type ICheckboxInputProps = ICommonFieldProps & {
  active?: boolean;
  mandatory?: boolean;
  onBlur?: Function;
  onFocus?: Function;
  onChange?: Function;
  readOnly?: boolean;
  includeLabel?: boolean;
  flexBox?: boolean;
  id?: string;
  hint?: ReactNode;
  value?: Maybe<boolean>; //'undefined/null' will be treated as false
  message?: Array<string>;
  showWhenNotActive?: boolean;
  label?: string;
  inGrid?: boolean;
  touched?: boolean;
  tabIndex?: number;
  testId?: string;
  'data-testid'?: string;
  customValidationErrors?: any;
  setInputRef?: Function;
  disabled?: boolean;
  reformatLabel?: boolean;
};

export default class CheckboxInput extends Component<ICheckboxInputProps, { error: any; errorInfo: any }> {
  static defaultProps: {
    onChange: () => void;
    active: boolean;
    showWhenNotActive: boolean;
    readOnly: boolean;
    inputCols: string;
    label: string;
    message: any[];
    mandatory: boolean;
    onFocus: () => void;
    onBlur: () => void;
    hint: string;
    labelCols: string;
    includeLabel: boolean;
    id: string;
    value: boolean;
    flexBox: boolean;
  };

  render() {
    const {
      active,
      id,
      label,
      includeLabel,
      inGrid,
      flexBox,
      labelCols,
      inputCols,
      readOnly,
      hint,
      showWhenNotActive,
      onBlur,
      onFocus,
      onChange,
      touched,
      tabIndex,
      customValidationErrors,
      setInputRef,
      disabled,
      reformatLabel,
    } = this.props;

    const labelProps: IInputLabelProps = {
      flexBox,
      id,
      includeLabel,
      hint,
      label,
      readOnly,
      reformatLabel,
    };
    const value = this.props.value;
    const CheckboxInput = (
      <Checkbox
        id={id}
        onBlur={onBlur}
        onChange={onChange as any}
        onFocus={onFocus}
        value={value as any}
        checked={!!value}
        tabIndex={tabIndex}
        data-testid={this.props['data-testid'] || this.props.testId}
        readOnly={readOnly}
        setInputRef={setInputRef}
        style={inGrid && !labelProps?.includeLabel ? { left: '10px', top: '6px' } : null}
      />
    );
    if (inGrid) return CheckboxInput;
    return (
      <InputBlock flexBox={flexBox}>
        <InputLabel {...labelProps} cols={labelCols} />
        <InputGroup flexBox={flexBox} cols={inputCols} withLabel={includeLabel}>
          {CheckboxInput}
          <InputErrorMessage
            label={label}
            active={active}
            touched={touched}
            showWhenNotActive={showWhenNotActive}
            customValidationErrors={customValidationErrors}
          />
        </InputGroup>
      </InputBlock>
    );
  }
}

CheckboxInput.defaultProps = {
  active: false,
  mandatory: false,
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
  includeLabel: true,
  readOnly: false,
  flexBox: true,
  labelCols: 'min',
  inputCols: 'max',
  value: false,
  message: [],
  hint: '',
  showWhenNotActive: false,
  label: '',
  id: '',
};

/**
 * Short-term solution to being able to use CheckboxInput with correct typing.
 * Longer term should migrate it to a Function Component and remove this type override.
 */
export const TypedCheckboxInput = CheckboxInput as unknown as (props: ICheckboxInputProps) => ReactElement;
